<template>
  <div class="ClienteList">
    <v-card class="card-size">
      <v-card-title>
        <h2 class="headline mb-0">{{ $tc('title.cliente', 2) }}</h2>
      </v-card-title>

      <cliente-sidebar
        v-if="canAccessCRUD && tipoImportacao"
        ref="sidebar">
      </cliente-sidebar>

      <cliente-list-dados :canAccessCRUD="canAccessCRUD"
        @TABELA_EXPORTAR_DADOS="requestExportacao"
        @TABELA_IMPORTAR_DADOS="$refs.sidebar.open()"
        ref="tabelaCliente">
      </cliente-list-dados>

      <v-card-actions v-if="canAccessCRUD">
        <v-row>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn id="btn_novo" fab @click="novo" class="v-btn__fab" color="primary" v-on="on" bottom right fixed>
                <v-icon>add</v-icon>
              </v-btn>
            </template>
            <span>{{$t('label.novo')}}</span>
          </v-tooltip>
        </v-row>
      </v-card-actions>

    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ClienteListDados from '@/spa/cliente/ClienteListDados';
import { generateComputed } from '../../common/functions/roles-computed-generator';
import exportacao from '../../common/functions/exportacao';
import ClienteSidebar from './ClienteSidebar';

export default {
  name: 'ClienteList',
  data() {
    return {
      metadadoResource: this.$api.metadado(this.$resource),
    };
  },
  components: {
    ClienteListDados,
    ClienteSidebar,
  },
  computed: {
    ...generateComputed('CLIENTE', [
      'canAccessPage',
      'canAccessCRUD',
    ]),
    ...mapGetters('importacao', {
      tiposImportacao: 'getTiposImportacao',
    }),
    tipoImportacao() {
      return this.tiposImportacao.find((el) => el.nome === 'importacao_cliente');
    },
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast(this.$t('message.acesso_negado'));
      }
    },
    novo() {
      this.$router.push({ name: 'novoCliente' });
    },
    requestExportacao(cb) {
      const params = {
        filtro: this.$refs.tabelaCliente.getSearchQuery() || '',
      };
      exportacao.exportar(cb, 'cliente_pasta_trabalho', this, params, 5000, 0);
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};
</script>
